import React, { Component } from "react";
import SEO from "react-seo-component";
import { Col, Container, Row } from "reactstrap";

class Section extends Component {
  render() {
    return (
      <React.Fragment>
        <SEO
          title={
            "QikTruck In-Service Training Program – Logistics, Transport & Supply Chain"
          }
          titleTemplate={"QikTruck"}
          titleSeparator={`-`}
          description={
            "Gain workplace experience in South Africa’s on-demand logistics industry. 6–12 month rotations across Operations, Driver Management, Fleet Analytics, Customer Service and Marketing."
          }
          image={"https://media.qiktruck.co.za/qiktruck-preview-header.png"}
          pathname={"https://qiktruck.co.za/in-service-training"}
          twitterUsername={"qiktrucksa"}
        />
        <section id="home">
          <Container>
            <Row className="justify-content-center">
              <Col>
                <div className="hero-wrapper mb-4 about-us">
                  <img
                    src="/in-service-training-banner.jpg"
                    alt="QikTruck in-service trainees"
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: 12,
                      marginBottom: 16,
                      objectFit: "cover",
                    }}
                  />
                  <h1 id="home" style={{textAlign: "left"}}>QikTruck In-Service Training Program</h1>
                  <p className="quote">
                    Bridge academic learning with real operational exposure in a
                    modern, digital logistics marketplace.
                  </p>
                  <div
                    className="badges"
                    style={{ display: "flex", gap: 12, flexWrap: "wrap" }}
                  >
                    <span className="badge badge-success">6–12 months</span>
                    <span className="badge badge-info">TVET & UoT</span>
                    <span className="badge badge-primary">
                      Logistics • Transport • Supply Chain • Business Admin
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section id="program">
          <Container>
            <Row>
              <Col lg={12}>
                <h2>Purpose</h2>
                <p>
                  The program provides structured workplace experience for
                  students pursuing logistics-related qualifications. The aim is
                  to build practical capabilities that complement academic
                  outcomes.
                </p>
                <h3>Duration</h3>
                <p>
                  6 to 12 months, aligned with institutional requirements (e.g.,
                  N6 6-month placement or 12-month internship).
                </p>
                <h3>Eligibility</h3>
                <ul>
                  <li>
                    Registered at a recognized TVET College or University of
                    Technology
                  </li>
                  <li>Studying a logistics-related qualification</li>
                  <li>Completed at least 50% of academic program</li>
                  <li>Provide institutional WIL letter</li>
                  <li>
                    Available for full duration; comply with safety standards
                  </li>
                </ul>
              </Col>
            </Row>
          </Container>
        </section>

        <section id="modules">
          <Container>
            <Row>
              <Col lg={12}>
                <h2>Rotations</h2>
                <div
                  className="cards"
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fill, minmax(260px, 1fr))",
                    gap: 16,
                  }}
                >
                  <div className="card modern-card">
                    <div className="card-body">
                      <h4>Operations Desk</h4>
                      <p>
                        Trip scheduling, dispatch coordination, customer
                        support.
                      </p>
                    </div>
                  </div>
                  <div className="card modern-card">
                    <div className="card-body">
                      <h4>Driver & Partner Management</h4>
                      <p>
                        Vehicle verification, partner onboarding, compliance
                        tracking.
                      </p>
                    </div>
                  </div>
                  <div className="card modern-card">
                    <div className="card-body">
                      <h4>Fleet & Route Analytics</h4>
                      <p>
                        Cost per km, fuel tracking, route and trip optimization.
                      </p>
                    </div>
                  </div>
                  <div className="card modern-card">
                    <div className="card-body">
                      <h4>Customer Service & Bookings</h4>
                      <p>Quoting, order management, customer communication.</p>
                    </div>
                  </div>
                  <div className="card modern-card">
                    <div className="card-body">
                      <h4>Marketing & Data Insights</h4>
                      <p>Campaigns, dashboards and performance reporting.</p>
                    </div>
                  </div>
                </div>
                <br />
                <h3>Supervision & Evaluation</h3>
                <ul>
                  <li>
                    Assigned Training Supervisor for guidance and tracking
                  </li>
                  <li>WIL Logbook signing and institutional evaluations</li>
                  <li>Certificate of Completion on success</li>
                </ul>
              </Col>
            </Row>
          </Container>
        </section>

        <section id="apply">
          <Container>
            <Row>
              <Col lg={12}>
                <h2>Stipend & Work Conditions</h2>
                <p>
                  Recommended stipend: Transport and other benefits included.
                  Commissions are paid for all trips completed.
                </p>
                <h3>Learning Outcomes</h3>
                <ul>
                  <li>Understand a digital logistics marketplace</li>
                  <li>Plan, quote and manage transport orders</li>
                  <li>Interpret operational data and KPIs</li>
                  <li>Effective driver and customer communication</li>
                  <li>Apply safety, compliance and data protection policies</li>
                </ul>
                <h3>Completion & Opportunities</h3>
                <p>
                  Certificate of In-Service Training. Institutional verification
                  provided. High performers may be considered for roles.
                </p>
                <div
                  className="cta"
                  style={{ display: "flex", gap: 12, flexWrap: "wrap" }}
                >
                  <a
                    className="btn btn-primary"
                    href="https://forms.gle/UAzik2h8oZc5uWoa8"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Apply for In‑Service Training
                  </a>
                  <a
                    className="btn btn-outline-secondary"
                    href="https://careers.qiktruck.co.za"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Jobs & Internships
                  </a>
                </div>
                <p style={{ marginTop: 16 }}>
                  Institutions and WIL coordinators: partner with QikTruck to
                  formalize placement pipelines under TETA guidelines.
                </p>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
